'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import useBroadcastChannel from '../../utils/useBroadcastChannel';
import { browserUniqueId } from './useSendAuthBC';
export type AuthBroadcastChannelMessageType = 'login' | 'logout' | 'join';
interface Props {
  onLogin?: () => void;
  onLogout?: () => void;
  onJoin?: () => void;
}
function useReceiveAuthBC(t0) {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onLogin,
    onLogout,
    onJoin
  } = t1;
  const {
    receivedMessage
  } = useBroadcastChannel("auth");
  let t2;
  if ($[2] !== onJoin || $[3] !== onLogin || $[4] !== onLogout || $[5] !== receivedMessage) {
    t2 = () => {
      if (!receivedMessage) {
        return;
      }
      if (receivedMessage.type === "login") {
        if (receivedMessage.payload !== browserUniqueId) {
          if (onLogin) {
            onLogin();
          } else {
            window.location.reload();
          }
        }
      }
      if (receivedMessage.type === "logout") {
        if (receivedMessage.payload !== browserUniqueId) {
          if (onLogout) {
            onLogout();
          } else {
            window.location.reload();
          }
        }
      }
      if (receivedMessage.type === "join") {
        if (receivedMessage.payload !== browserUniqueId) {
          if (onJoin) {
            onJoin();
          } else {
            window.location.reload();
          }
        }
      }
    };
    $[2] = onJoin;
    $[3] = onLogin;
    $[4] = onLogout;
    $[5] = receivedMessage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== receivedMessage) {
    t3 = [receivedMessage];
    $[7] = receivedMessage;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
}
export default useReceiveAuthBC;